import AuthContext from 'context/AuthContext'
import { isEmpty } from 'lodash'
import { useContext } from 'react'
import { Navigate } from 'react-router-dom'

function AuthorizationRoute (props) {
  const { user } = useContext(AuthContext)

  const checkPermission = () => {
    return true
  }

  let route = checkPermission() ? (<>{props?.children}</>) : (<Navigate to='/' />)
  return (
    <>
      {
        !isEmpty(user) ? (<> {route}</>) : (<Navigate to='/login' />)
      }
    </>
  )
}

export default AuthorizationRoute
